import { Injectable } from '@angular/core';
import { ProductTypeEnum } from '../../model/enums/ProductTypeEnum';
import NavigationSteps from './navigation-steps';

interface NavigationStep {
  label: string;
  order: number;
  active: boolean;
  finished: boolean;
}

export enum StepsORV {
  CALCULATE,
  PERSONAL_DATA,
  INSURANCE_DATA,
  COMPLETE
}

export enum StepsGG {
  CALCULATE,
  PRODUCT_INFO,
  KNOWLEDGE_TEST,
  PERSONAL_DATA,
  COMPLETE,
}

@Injectable({
  providedIn: 'root'
})
export default class NavigationSettings {
  steps: Array<NavigationStep>;

  setStepsByProductType(product: ProductTypeEnum): void {
    this.steps = NavigationSteps[product];
  }

  setFinishedState(index: number, finished: boolean): void {
    this.steps[index].finished = finished;
  }

  setActiveState(index: number, active: boolean): void {
    this.steps[index].active = active;
  }

  setCurrentActiveStepAsInactive(): void {
    const currentStepIndex = this.getIndexOfCurrentStep();
    this.steps[currentStepIndex].active = false;
  }

  getIndexOfCurrentStep(): number {
    return this.steps.findIndex((step): boolean => step.active);
  }

  reset(): void {
    this.steps = this.steps.map((step) => {
      step.active = false;
      step.finished = false;
      return step;
    });
  }
}
